module.exports = __webpack_public_path__ + "style/img/shuziren.93419b35.jpg";